export const selectAllTables = (state) => state.psqlEdit.allTables;
export const selectError = (state) => state.psqlEdit.error;
export const selectTheTable = (state) => state.psqlEdit.theTable;
export const selectTheTableMeta = (state) => state.psqlEdit.theTableMeta;
